"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropertiesI18nBundle = void 0;
var bundle_1 = require("./bundle");
Object.defineProperty(exports, "getPropertiesI18nBundle", { enumerable: true, get: function () { return bundle_1.getPropertiesI18nBundle; } });
//# sourceMappingURL=index.js.map